export default __webpack_public_path__ + "static/media/rm3.accc920a.png";